import React, { createContext, useContext } from 'react';

import useStoreLocator, { IUseStoreLocator } from './use-store-locator';

export const StoreLocatorContext = createContext<IUseStoreLocator>({} as IUseStoreLocator);

export const useStoreLocatorContext = () => useContext(StoreLocatorContext);

export const StoreLocatorProvider: React.FC = ({ children }) => {
  const {
    ErrorDialog,
    Dialog,
    activeStoreId,
    hasPanned,
    map,
    onClickSearch,
    redirectUrl,
    searchingNearby,
    searchingRecent,
    searchingFavs,
    setActiveStoreId,
    nearbyStoreCardRefs,
    storesNearby,
    storesFavs,
    storesRecent,
    zoom,
    displayMapViewTabs,
    currentTab,
    handleTabChange,
    setIsStoreInfoModalOpen,
    storeLocatorDispatch,
    currentTabHasError,
    locatorTabs,
    currentTabIndex,
    locatorTabIds,
    currentView,
    currentViewIsList,
    currentViewIsMap,
    updateStoreLocatorView,
  } = useStoreLocator();

  return (
    <StoreLocatorContext.Provider
      value={{
        ErrorDialog,
        Dialog,
        activeStoreId,
        hasPanned,
        map,
        onClickSearch,
        redirectUrl,
        searchingNearby,
        searchingRecent,
        searchingFavs,
        setActiveStoreId,
        nearbyStoreCardRefs,
        storesNearby,
        storesFavs,
        storesRecent,
        zoom,
        displayMapViewTabs,
        currentTab,
        handleTabChange,
        setIsStoreInfoModalOpen,
        storeLocatorDispatch,
        currentTabHasError,
        locatorTabs,
        currentTabIndex,
        locatorTabIds,
        currentView,
        currentViewIsList,
        currentViewIsMap,
        updateStoreLocatorView,
      }}
    >
      {children}
    </StoreLocatorContext.Provider>
  );
};
